module.exports = __webpack_public_path__ + "img/sagittarius.e9905430.svg";